import React, { useMemo } from 'react';
import { Config } from '../../helpers/config';
import { Vote } from '../../models';
import { IconProps, StarIcon } from '../Icons';
import './Stars.css';

export type StarsProps = {
  filledStarsNumber?: number;
  color?: string;
  containerClass?: string;
  useDefaultColor?: boolean;
  onStarClick?: (index: Vote) => void;
} & IconProps;

export const Stars: React.FC<StarsProps> = ({
  filledStarsNumber = 0,
  width = '16',
  height = '15',
  color = '#4A4A4A',
  useDefaultColor,
  containerClass = '',
  onStarClick,
}) => {
  const filledStarsColor = useMemo(() => {
    switch (filledStarsNumber) {
      case 1:
        return Config.red;
      case 2:
      case 3:
      case 4:
        return Config.primaryColor;
      case 5:
        return Config.green;
      default:
        return color;
    }
  }, [color, filledStarsNumber]);

  return (
    <div className={`stars--container ${containerClass}`}>
      {Array(filledStarsNumber)
        .fill(undefined)
        .map((_, i) => {
          return (
            <span
              onClick={() => onStarClick?.((i + 1) as Vote)}
              role={onStarClick ? 'button' : 'img'}
              aria-label={!onStarClick ? 'filled star' : `Star ${i + 1} filled`}
              key={i}
              className={`stars--star ${onStarClick ? 'clickable' : ''}`}
            >
              <StarIcon
                color={useDefaultColor ? color : filledStarsColor}
                width={width}
                height={height}
                isFilled
              />
            </span>
          );
        })}
      {Array(5 - filledStarsNumber)
        .fill(undefined)
        .map((_, i) => {
          return (
            <span
              onClick={() => onStarClick?.((i + filledStarsNumber + 1) as Vote)}
              role={onStarClick ? 'button' : 'img'}
              aria-label={
                !onStarClick
                  ? 'empty star'
                  : `Star ${i + filledStarsNumber + 1} empty`
              }
              key={i}
              className={`stars--star ${onStarClick ? 'clickable' : ''}`}
            >
              <StarIcon color={color} width={width} height={height} />
            </span>
          );
        })}
    </div>
  );
};
